import { basicExtensions, useEditor } from '@modules/editor';
import { chatImagePasteExtension } from '@modules/editor/extensions/chatImagePaste';
import { emojiSearchExtension } from '@modules/editor/extensions/emojiSearch';
import { userMentionExtension } from '@modules/editor/extensions/userMention';
import { useWorkspaceInfoContextStore } from '@modules/workspace/providers/WorkspaceInfo';
import { IWorkspaceUser } from 'src/@types/workspace-info';
import { useAuthContext } from 'src/auth/useAuthContext';

type Props = {
  conversationId: string;
  mentionableParticipants?: IWorkspaceUser[];
  handleChatUploadFile?: (file: File) => void;
  placeholder?: string;
};

const extensions = [
  ...basicExtensions,
  userMentionExtension,
  emojiSearchExtension,
  chatImagePasteExtension,
  // spaceForAiExtension,
];

/**
 * @deprecated you should be using useConversationEditorConfig value provided via context and useConversationEditor to instanciate the editor with draft feature
 */
export const useConversationEditorExtensions = ({
  conversationId,
  mentionableParticipants = [],
  handleChatUploadFile,
  placeholder = 'Type a message. Use @ to quote a user',
}: Props) => {
  const { user } = useAuthContext();
  const workspaceStore = useWorkspaceInfoContextStore();

  const { editor, currentValue, editorLoaded } = useEditor(
    {
      extensions,
      content: '',
      extensionConfig: {
        enterBehave: {
          createNewLine: false,
        },
        placeholder,
        userMention: {
          enabled: true,
          currentUserId: user?._id,
          mentionableUsers: mentionableParticipants,
        },
        chatUploadFile: handleChatUploadFile,
      },
      externalStores: {
        workspaceStore,
      },
    },
    [],
  );

  return { editor, currentValue, editorLoaded };
};
